// Tipos unificados para usuários
// Este arquivo resolve o conflito entre AuthUser e User

export interface BaseUser {
  nome: string;
  email: string;
}

// Tipo para dados de autenticação (mais completo, vem da API)
export interface AuthUser extends BaseUser {
  id: number;
  is_active: boolean;
  is_staff: boolean;
  [key: string]: any;
}

// Tipo para dados de formulário/cadastro (pode incluir password e equipe)
export interface FormUser extends BaseUser {
  password?: string;
  id_equipe?: number;
}

// Tipo para compatibilidade com o código existente
export type User = AuthUser | FormUser;

// Function para verificar se é AuthUser
export function isAuthUser(user: User): user is AuthUser {
  return 'id' in user && 'is_active' in user;
}

// Function para converter FormUser para AuthUser (simulado)
export function toAuthUser(formUser: FormUser, id: number = 0): AuthUser {
  return {
    id,
    nome: formUser.nome,
    email: formUser.email,
    is_active: true,
    is_staff: false,
  };
}